<!-- <header>
  <img src="/icons/murmure-logo.svg" alt="">
  <ul>
    <li>
      <a href="">à propos</a>
    </li>
    <li>
      <a [routerLink]="'/prestations'">Préstations</a>
    </li>
    <li>
      <a href="">Boite à outils</a>
    </li>
    <li>
      <a [routerLink]="'/blog'">Blog</a>
    </li>
    <li>
      <a [routerLink]="'/contact'">Contact</a>
    </li>
  </ul>
</header> -->
<router-outlet></router-outlet>
<!-- <footer>
  <img src="assets/image.png" alt="murmures">
  <ul>
    <li>
      <ul>
        <p>ENTREPRISE</p>
        <li>CGU / Politique de confidentialité</li>
        <li>CGV</li>
        <li>Mentions légales</li>
      </ul>
    </li>
    <li>
      <ul>
        <p>CONTACT</p>
        <li>Téléphone</li>
        <li>Mail</li>
      </ul>
    </li>
    <li>
      <p>RESEAUX SOCIAUX</p>
      <div>
        <div class="social-network">fb</div>
        <div class="social-network">insta</div>
        <div class="social-network">linkedin</div>
      </div>
    </li>
  </ul>
  <p>&#64;2025 - Murmures 🦡 - Tous droits réservés</p>
</footer> -->